export default "__VITE_ASSET__COnDsFI3__"